import "@fontsource-variable/inter";
import "./src/styles/global.css";

// gatsby-plugin-image fades server-rendered images in from a small inline
// script. If an image finishes loading (e.g. from cache) before that script
// runs, the fade never happens and the image stays at opacity 0. After the
// first render, reveal any image that has loaded but is still hidden.
export const onInitialClientRender = () => {
  window.setTimeout(() => {
    document.querySelectorAll("img[data-main-image]").forEach((img) => {
      if (img.complete && img.naturalWidth > 0 && img.style.opacity === "0") {
        img.style.opacity = "1";
        const placeholder = img
          .closest("[data-gatsby-image-wrapper]")
          ?.querySelector("[data-placeholder-image]");
        if (placeholder) placeholder.style.opacity = "0";
      }
    });
  }, 100);
};
